import { useDispatch } from "react-redux";
import { setAccessToken } from "redux/actions/auth-actions";
import axios from "axios";
import CONFIG from "@/config";

const authUrl = `${CONFIG.API_BASE_URL}/auth-service/api/v1/auth`;

export const useRefreshToken = () => {
  const dispatch = useDispatch();

  const refresh = async () => {
    const res = await axios.post(
      `${authUrl}/refresh-token`,
      {},
      {
        withCredentials: true,
        headers: {
          "Client-Type": "ADMIN",
          "Client-Id": "WAYAQUICK",
        },
      },
    );

    const newToken = res?.data?.data?.token ?? res?.data?.token;
    dispatch(setAccessToken({ token: newToken }));
    return newToken;
  };

  return refresh;
};
